import { jsx as _jsx } from "react/jsx-runtime";
const ChevronIcon = ({ ...props }) => (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { d: "M8.00004 8.7031L5.03004 5.7331L4.18164 6.5815L8.00004 10.3999L11.8184 6.5815L10.97 5.7331L8.00004 8.7031Z", fill: "currentColor" }) }));
export default ChevronIcon;
